// @ts-check

import * as Sentry from "@sentry/react";
import { getModalityLabel } from "@/components/chat-report-panel/ReportFormDialog"
import ToolCall from "@/components/tool-call"
import { FileText } from "lucide-react"
import { z } from "zod"
import { ChatMarkdown } from "../ChatBubble"
import { parseJsonToMarkdown } from "@/components/chat-report-panel/utils"

const GenerateReportArgsSchema = z.object({
  modality: z.string(),
  age: z.string(),
  gender: z.string(),
}).passthrough()

const GenerateReportResultSchema = z.object({
  content: z.string(),
})

function safeParseJsonToMarkdown(report = "") {
  try {
    return parseJsonToMarkdown(report)
  } catch(err) {
    Sentry.captureException(err, {
      extra: {
        context: 'GenerateReportUI - parseJsonToMarkdown',
        reportLength: report?.length || 0,
        reportPreview: report?.substring(0, 100) || 'empty'
      }
    });
    return null
  }
}

/** @param {import(".").ToolComponentProps<typeof GenerateReportArgsSchema, typeof GenerateReportResultSchema>} props */
function GenerateReportUI({ args, result, state }) {
  const output = (() => {
    if(result == null) return null
    if(result instanceof Error) return result.message
    return result.content
  })()

  return (
    <ToolCall state={state}>
      <ToolCall.Header>
        <FileText size={16} className="shrink-0" />
        <ToolCall.Action>Generate Report</ToolCall.Action>
        <ToolCall.Input>
          <span>{getModalityLabel(args.modality)}</span>
          <span className="mx-1.5">•</span>
          <span>{args.age} years</span>
          <span className="mx-1.5">•</span>
          <span>{args.gender}</span>
        </ToolCall.Input>
      </ToolCall.Header>

      <ToolCall.Content>
        <ToolCall.Output>
          {state === ToolCall.State.SUCCESS ? (
            <ChatMarkdown>{safeParseJsonToMarkdown(output)}</ChatMarkdown>
          ): output}
        </ToolCall.Output>
      </ToolCall.Content>
    </ToolCall>
  )
}

export {
  GenerateReportArgsSchema,
  GenerateReportResultSchema,
  GenerateReportUI,
}